const cleanLine = (line) => {
  return line.map(l => l.replace(/"/g, '').trim())
}

export default function csvToMatrix(csv) {
  if (typeof csv !== 'string')
    throw 'Must pass a string'

  const lines = csv.split('\n').map(line => line.split(';'))
  const newLines = []

  for (const line of lines) {
    const newLine = cleanLine(line)
    if (newLine.some(l => l.length > 0))
      newLines.push(newLine)
  }

  return newLines
}
